import React, {MouseEvent} from 'react';
import {get} from 'lodash';

import CheckboxField from 'components/CheckboxField';
import Typography from 'components/Typography';

import {Order} from 'types';

import styles from './InboxTicket.module.scss';
import classNames from 'classnames';

interface TicketProps {
  ticket: Order;
  index?: number;
  selected?: boolean;
  onChangeCheckbox: (id: number, checked: boolean) => void;
  onOrdersClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  isError?: boolean;
}

function Ticket({
  ticket,
  index,
  selected,
  onChangeCheckbox,
  onOrdersClick,
}: TicketProps) {
  const delivery_address = ticket?.delivery_address;
  const id = ticket?.id;
  const is_redispatch = ticket?.is_redispatch;
  const orders = ticket?.orders;
  const customer = ticket?.customer;

  const handleOrderClick = (e: MouseEvent<HTMLDivElement>) => {
    onOrdersClick(e);
  };

  return (
    <div
      className={classNames(
        styles.root,
        // Add border color for invalid addresses or error states
        typeof delivery_address !== 'string' &&
          !delivery_address?.is_valid &&
          styles.borderColor
      )}
    >
      <div style={{marginBottom: index ? 0 : 8}} className={styles.top}>
        {/* Checkbox for order selection */}
        <CheckboxField
          name={`checkbox-${id}`}
          className={styles.checkbox}
          label={`#${id}`}
          checked={selected}
          onChange={() => onChangeCheckbox(id, !selected)}
        />
        <div
          className={classNames(
            styles.orderCountQuad,
            is_redispatch ? styles.redispatch : undefined
          )}
          onClick={handleOrderClick}
        >
          {orders.length}
        </div>
      </div>

      {/* Customer name - handle both string and object formats */}
      {typeof customer === 'string' ? (
        <Typography className={styles.customer} variant="p">
          {customer}
        </Typography>
      ) : (
        <Typography className={styles.customer} variant="p">
          {get(customer, 'user.first_name', '')}{' '}
          {get(customer, 'user.last_name', '')}
        </Typography>
      )}

      {/* Delivery address - handle both string and object formats */}
      {typeof delivery_address === 'string' ? (
        <Typography className={styles.addressCalc} variant="p">
          {delivery_address}
        </Typography>
      ) : (
        <Typography className={styles.address} variant="p">
          {delivery_address?.address_line_1 || ''}{' '}
          {delivery_address?.address_line_2 || ''} <br />
          {delivery_address?.city}, {delivery_address?.state}{' '}
          {delivery_address?.zipcode}
        </Typography>
      )}
    </div>
  );
}

export default Ticket;
